import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET `/mom/work-order/{workOrderId}/stock-issue/{stockIssueId}`（nested detail）。
 * 單號 `issueNo`＝`OR`+YYMMDD+2 位；欄位含 `category`、`lines[].lossQty` 等（見契約）。
 *
 * @param {string} workOrderId
 * @param {string} stockIssueId
 */
export async function fetchWorkOrderStockIssueDetail(workOrderId, stockIssueId) {
  const { data: raw } = await request.get(
    `/mom/work-order/${workOrderId}/stock-issue/${stockIssueId}`,
  );
  return parseVer4DetailResponse(raw);
}
